import { Trans, useTranslation } from 'react-i18next';
import { Glyphicon } from 'react-bootstrap';
import CheckboxField from '../../../../../components/forms/checkboxField/CheckboxField';
import {
  OwnerFormula,
  PropertyOwnerPermissionType,
} from '../../../../../models/Owner';
import RadioGroupField from '../../../../../components/forms/radioGroupField/RadioGroupField';
import Tooltip from '../../../../../components/tooltip/Tooltip';
import {
  OwnerPermissionsModalContainer,
  TooltipContent,
} from './OwnerPermissionsModal.styles';

const formulaOptions = [
  {
    value: OwnerFormula.DEFAULT,
  },
  {
    value: OwnerFormula.RENTAL_REVENUE,
  },
  {
    value: OwnerFormula.RENTAL_REVENUE_AND_CLEANING_FEE,
  },
  {
    value: OwnerFormula.RENTAL_REVENUE_MINUS_AGENCY_COMMISSION,
  },
];

export const OwnerPermissionsFormFields = () => {
  const { t } = useTranslation();

  const radioOptions = formulaOptions.map((option) => {
    const labelText = t(
      `pageProperty.owners.permissionsModal.formula.${option.value}.text`,
    );
    const tooltipText = t(
      `pageProperty.owners.permissionsModal.formula.${option.value}.tooltip`,
    );

    return {
      value: option.value,
      label: (
        <>
          {labelText}{' '}
          <Tooltip
            id={`formula-${option.value}-tooltip`}
            text={<TooltipContent>{tooltipText}</TooltipContent>}
            placement="right"
          >
            <Glyphicon
              glyph="info-sign"
              id={`formula-${option.value}-info-icon`}
              data-testid={`formula-${option.value}-info-icon`}
            />
          </Tooltip>
        </>
      ),
    };
  });

  return (
    <>
      <CheckboxField name={PropertyOwnerPermissionType.READING_CALENDAR}>
        {t('pageProperty.owners.permissionsModal.options.READING_CALENDAR')}
      </CheckboxField>

      <CheckboxField name={PropertyOwnerPermissionType.READING_BOOKING_DETAILS}>
        {t(
          'pageProperty.owners.permissionsModal.options.READING_BOOKING_DETAILS',
        )}
      </CheckboxField>

      <CheckboxField
        name={PropertyOwnerPermissionType.READING_BOOKING_VALUE}
        className="subCheckbox"
      >
        {t(
          'pageProperty.owners.permissionsModal.options.READING_BOOKING_VALUE',
        )}
      </CheckboxField>

      <CheckboxField name={PropertyOwnerPermissionType.CREATING_BLOCKS}>
        {t('pageProperty.owners.permissionsModal.options.CREATING_BLOCKS')}
      </CheckboxField>

      <CheckboxField name={PropertyOwnerPermissionType.VIEW_ANALYTICS}>
        {t('pageProperty.owners.permissionsModal.options.VIEW_ANALYTICS')}
      </CheckboxField>

      <OwnerPermissionsModalContainer>
        <p className="formula-radio-title">
          <Trans
            i18nKey="pageProperty.owners.permissionsModal.formula.title"
            components={{
              link1: (
                // eslint-disable-next-line jsx-a11y/control-has-associated-label, jsx-a11y/anchor-has-content
                <a
                  target="_blank"
                  data-testid="alteration-request-documentation"
                  href="https://help.hostfully.com/en/articles/1674802-use-the-owner-portal"
                  rel="noreferrer"
                />
              ),
            }}
          />
        </p>
        <RadioGroupField name="formula" id="formula" options={radioOptions} />
      </OwnerPermissionsModalContainer>
    </>
  );
};
